module.exports = __webpack_public_path__ + "static/media/back.3b8dd4ee.svg";